import { render, staticRenderFns } from "./PreviewScheme.vue?vue&type=template&id=a30bb64c&scoped=true&"
import script from "./PreviewScheme.vue?vue&type=script&lang=js&"
export * from "./PreviewScheme.vue?vue&type=script&lang=js&"
import style0 from "./PreviewScheme.vue?vue&type=style&index=0&id=a30bb64c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30bb64c",
  null
  
)

export default component.exports